import { render, staticRenderFns } from "./DeliveryPointGalleryCard.vue?vue&type=template&id=2b0bc034&scoped=true"
import script from "./DeliveryPointGalleryCard.vue?vue&type=script&lang=js"
export * from "./DeliveryPointGalleryCard.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPointGalleryCard.vue?vue&type=style&index=0&id=2b0bc034&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0bc034",
  null
  
)

export default component.exports